/* Enable card-gallery arrows only after a deliberate horizontal swipe or drag.
   Delegated listeners also support product cards inserted by dynamic sections. */
(() => {
  let gesture = null;
  const galleryFrom = (target) =>
    target instanceof Element ? target.closest('product-card .card-gallery slideshow-component') : null;

  document.addEventListener('pointerdown', (event) => {
    if (!event.isPrimary || event.target.closest?.('button, input, select, textarea')) return;
    const gallery = galleryFrom(event.target);
    gesture = gallery ? { gallery, id: event.pointerId, x: event.clientX, y: event.clientY } : null;
  }, true);

  document.addEventListener('pointermove', (event) => {
    if (!gesture || event.pointerId !== gesture.id) return;
    const dx = Math.abs(event.clientX - gesture.x);
    const dy = Math.abs(event.clientY - gesture.y);
    if (dx >= 12 && dx > dy) {
      gesture.gallery.dataset.awGalleryUsed = 'true';
    }
  }, true);

  for (const type of ['pointerup', 'pointercancel']) {
    document.addEventListener(type, (event) => {
      if (gesture?.id === event.pointerId) gesture = null;
    }, true);
  }

  document.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaX) > 10 && Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      galleryFrom(event.target)?.setAttribute('data-aw-gallery-used', 'true');
    }
  }, { capture: true, passive: true });
})();
